<template>
    <div class="az-form-content">
        <v-container fluid grid-list-xl>
            <v-layout wrap align-center>
                <v-flex xs12 sm12 d-flex v-if="!arquivoUpload">
                    <edl-file-upload height="80px" :accept="extensoesAceitas" :repository="repositorio" ref="azFileUploadEsclarecimento" :multiple="false" noUploadFile @payloadArquivo="enviarPayloadArquivo">
                        <a @click.prevent="$refs.azFileUploadEsclarecimento.openFileSelector()">
                            <v-icon>archive</v-icon>
                            Importar Arquivos
                        </a>
                    </edl-file-upload>
                </v-flex>
                <v-flex xs12 sm12 d-flex v-if="arquivoUpload">
                    <div class="container-anexos">
                        <div>
                          <span>Nome</span><br/>
                          <label>{{arquivoUpload.name}}</label>
                        </div>
                        <div class="container-acoes">
                          <span>Ações</span>
                          <div>
                            <v-tooltip top class="no-mobile">
                                <v-btn slot="activator" icon @click="baixarArquivo">
                                  <v-icon size="20">get_app</v-icon>
                                </v-btn>
                              <label>baixar arquivo</label>
                            </v-tooltip>
                            <v-tooltip top class="no-mobile">
                                <v-btn slot="activator" icon @click="confirmarRemocao">
                                    <v-icon size="20">close</v-icon>
                                </v-btn>
                                <label>remover arquivo</label>
                            </v-tooltip>
                          </div>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
        <az-confirm @onConfirm="removerArquivo(); mostrarDialogRemoverArquivo = false;"
                    @onDecline="mostrarDialogRemoverArquivo = false"
                    v-if="mostrarDialogRemoverArquivo">
            Tem certeza que deseja remover o anexo?
        </az-confirm>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import EdlFileUpload from "@/commons/components/file/EdlFileUpload.vue";

export default {
        name: 'LicitacaoEsclarecimentoAnexo',
        components: {EdlFileUpload},
        props: {
            tipo: {
                type: String,
                default: 'fornecedor'
            }
        },
        data() {
            return {
                licitacaoId: null,
                mostrarDialogRemoverArquivo: false,
                arquivoUpload: null,
                repositorio: null,
                extensoesAceitas: null
            }
        },
        computed: {
            ...mapState(['loki', 'parametros'])
        },
        created() {
            this.desabilitarLoadingGlobal()
        },
        beforeMount() {
            this.setLicitacaoId()
            this.configurarRepositorio()
            this.configurarExtensoesAceitas()
        },
        methods: {
            setLicitacaoId() {
                if(this.$route.params.id){
                    this.licitacaoId = this.$route.params.id
                }
            },
            configurarRepositorio(){
                this.repositorio = `repo1:licitacao/${this.licitacaoId}/${this.tipo}/${this.loki.user.id}`
                this.$emit('configuracaoRepositorio', this.repositorio)
            },
            configurarExtensoesAceitas(){
                this.extensoesAceitas = this.parametros.propriedadesLicitacao.extensao
            },
            confirmarRemocao() {
                this.mostrarDialogRemoverArquivo = true
            },
            enviarPayloadArquivo(arquivo){
                this.arquivoUpload = arquivo
                this.$emit('uploadArquivo', this.arquivoUpload)
            },
            baixarArquivo(){
                const fileURL = URL.createObjectURL(this.arquivoUpload);
                const link = document.createElement('a');
                link.href = fileURL;
                link.download = this.arquivoUpload.name;
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(fileURL);
            },
            removerArquivo() {
              this.arquivoUpload = null
              this.$emit('removerArquivoUpload')
            },
        }
    }
</script>

<style scoped lang="stylus">

.container-anexos
  margin-top 10px
  display flex
  justify-content space-between
  span
    font-weight bold
    color #777

.container-acoes
  display flex
  flex-direction column
  text-align center

</style>